import { Button } from '@mui/material';
import { AddIcon } from '@diligentcorp/atlas-react-icons';
import { useTranslation } from 'react-i18next';

export type SLAsGridToolbarAddSLAProps = {
  onAddSLAClick: () => void;
};

export function SLAsGridToolbarAddSLA(props: SLAsGridToolbarAddSLAProps) {
  const { onAddSLAClick } = props;
  const { t } = useTranslation('settings');

  return (
    <Button
      onClick={onAddSLAClick}
      variant='contained'
      startIcon={<AddIcon />}
      data-testid='add-sla-button'
    >
      {t('slaConfiguration.add')}
    </Button>
  );
}
